import s from "styled-components";

export const WrapToCenter = s.div`
  text-align: center;
`;
export const Wrap = s.div`
  display: inline-block;
  text-align: left;
  margin-top: 100px;
  @media(max-width: 991px) {
    margin-top: 0;
  }
`;

